import { createSelector } from 'reselect';
import ComparativePalletBoxUsageColumns
  from '../../containers/ComparativePalletBoxUsageColumns';
import ReportsDefinition from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.COMPARATIVE_PALLET_BOX_USAGE_961.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.COMPARATIVE_PALLET_BOX_USAGE_961.isLoading;

export const getData =
  ReportsDefinition.COMPARATIVE_PALLET_BOX_USAGE_961.getDataFunction();

export const getColumns =
  createSelector(getData, ComparativePalletBoxUsageColumns);
